// extracted by mini-css-extract-plugin
export default {"container":"Header_container__w9W3n","title":"Header_title__GQpxb"};